import {Component} from '@angular/core';

@Component({
    selector: 'vui-buttons',
    templateUrl: './buttons.component.html',
    styleUrls: ['./buttons.component.scss']
})
export class ButtonsComponent {

}
